import React, { useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
export var Ripple = React.forwardRef(function (_ref, ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$startScale = _ref.startScale,
      startScale = _ref$startScale === void 0 ? 0.3 : _ref$startScale,
      _ref$endScale = _ref.endScale,
      endScale = _ref$endScale === void 0 ? 2 : _ref$endScale;
  var rippleRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      onClick: function onClick() {
        // Todo: Possibly provide dynamic center point, similar
        // to material design.
        animateRipple(rippleRef.current, {
          startScale: startScale,
          endScale: endScale
        });
      }
    };
  });
  return /*#__PURE__*/React.createElement(StyledRipple, {
    $width: width,
    $height: height,
    ref: rippleRef
  });
});
var StyledRipple = styled.span.withConfig({
  displayName: "Ripple__StyledRipple",
  componentId: "vapor__njqh6m-0"
})(["border-radius:100%;width:", ";height:", ";top:0;left:0;transform:scale(0);opacity:1;position:absolute;background-color:", ";pointer-events:none;"], function (p) {
  return "".concat(p.$width, "px");
}, function (p) {
  return "".concat(p.$height, "px");
}, theme.colors.palette.whiteA20);

function animateRipple(el, _ref2) {
  var startScale = _ref2.startScale,
      endScale = _ref2.endScale;
  el.animate([{
    transform: "scale(".concat(startScale, ")")
  }, {
    transform: "scale(".concat(endScale, ")")
  }], {
    duration: 200,
    fill: 'both'
  });
  el.animate([{
    opacity: 1
  }, {
    opacity: 0
  }], {
    delay: 100,
    duration: 400,
    fill: 'both'
  });
}